








import Vue from 'vue'

export default Vue.extend({
  inheritAttrs: false,
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
})
